import {
  BoldPlugin,
  CodePlugin,
  ItalicPlugin,
  SubscriptPlugin,
  SuperscriptPlugin,
  UnderlinePlugin,
} from '@udecode/plate-basic-marks/react';
import { BlockquotePlugin } from '@udecode/plate-block-quote/react';
import { CodeBlockPlugin } from '@udecode/plate-code-block/react';
import { HeadingPlugin } from '@udecode/plate-heading/react';
import { all, createLowlight } from 'lowlight';

import { StrikePlugin } from './strike-plugin';

const lowlight = createLowlight(all);

export const basicNodesPlugins = [
  HeadingPlugin.configure({ options: { levels: 6 } }),
  BlockquotePlugin,
  CodeBlockPlugin.configure({ options: { lowlight } }),
  BoldPlugin,
  ItalicPlugin,
  UnderlinePlugin,
  StrikePlugin,
  CodePlugin,
  SubscriptPlugin,
  SuperscriptPlugin,
  UnderlinePlugin,
] as const;
